<template>
  <ClientOnly>
    <section
      v-if="Object.keys(props.data).length > 0"
      class="overview base-section sm"
      :class="[ props.data.parentClasses, props.data.parentStyle ? props.data.parentStyle : 'defaultStyle' ]"
    >
      <div class="container col">
        <strong class="label primary-color-text text-base-1 text-primary">{{ $t('overview') }}</strong>
        <div class="row">
          <div class="option-text col s12 m7 l8">
            <h2 v-html="convertToHtml(props.data.overview.subheadingHtml)"></h2>
            <p v-html="convertToHtml(props.data.overview.descriptionHtml)"></p>
            <p v-html="convertToHtml(props.data.overview.descriptionHtmlMore)"></p>
          </div>
          <div class="product-option-holder col s12 m5 l4">
            <template v-if="props.data.attributeValues">
              <div
                v-if="props.data.attributeValues.list && Object.keys(props.data.attributeValues.list).length"
                class="product-option-block"
              >
                <div class="h4 bold">
                  {{ props.data.attributeValues.title }}
                </div>
                <div
                  class="custom-radio-list row"
                >
                  <div
                    v-for="item, i in props.data.attributeValues.list"
                    :key="i"
                    class="col s3 l0 custom-radio-list__item"
                  >
                    <HelpersTooltipHelpers 
                      :data="{
                        parentClasses: 'radio-btn',
                        tooltip: props.data.attributeValues.tooltips ? `<div class='option-block-tooltip'>
                        <dl class='dimension-list'>
                          <dt>Docs</dt>
                          <dd class='size-spec'>${props.data.attributeValues.tooltips?.[i].Docs}</dd>
                          <dt>PDFs</dt>
                          <dd class='size-spec'>${props.data.attributeValues.tooltips?.[i].PDFs}</dd>
                          <dt>Photos</dt>
                          <dd class='size-spec'>${props.data.attributeValues.tooltips?.[i].Photos}</dd>
                          <dt>Songs</dt>
                          <dd class='size-spec'>${props.data.attributeValues.tooltips?.[i].Songs}</dd>
                          <dt>Movies</dt>
                          <dd class='size-spec'>${props.data.attributeValues.tooltips?.[i].Movies}</dd>
                        </dl>
                      </div>`
                          : null,
                        content: ` <span class='fake-btn'>${item}</span>`,
                        enableTooltip: props.data.attributeValues.tooltips
                      }"
                    />
                  </div>
                </div>
              </div>
            </template>

            <template v-if="props.data.colors">
              <template
                v-for="colorSection, i in props.data.colors"
              >
                <div
                  v-if="colorSection && colorSection.list && colorSection.list.length"
                  :key="i"
                  class="product-option-block"
                >
                  <div class="h4 bold">
                    {{ colorSection.title }}
                  </div>

                  <div class="color-picker">
                    <div
                      v-for="item, n in colorSection.list"
                      :key="n"
                      class="color-picker__item"
                    >
                      <HelpersTooltipHelpers 
                        :data="{
                          parentClasses: 'color-item fake-btn',
                          parentStyle: `background: #${item.hexCode}`,
                          tooltip: `<div class='option-block-tooltip'>
                          <p style='min-height: 110px;'><img src='${item.imageSrc ? item.imageSrc : '/img/na.png'}'></p>
                          <h5>${item.displayColor}</h5><span>${item.colorCode}</span>
                        </div>`,
                          content: null,
                          enableTooltip: colorSection.hasTooltip
                        }"
                      />
                    </div>
                  </div>
                  <div
                    v-if="props.options.settingsData.is_flash_drive"
                    class="option-block-footer"
                  >
                    <span
                      class="small"
                      v-html="$t('widgets.overview.descr')"
                    ></span>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </section>
  </ClientOnly>
</template>

<script setup>
/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  },
  options: {
    type: [Object],
    default: null
  }
})
</script>

<style lang="scss" scoped>
.overview {
  .product-option-block {
    padding-bottom: 1rem;
    .custom-radio-list {
      margin: 1rem -5px 0 -5px;
      &__item {
        padding: 0 5px !important;
        margin-bottom: 10px;
      }
      &:deep(.radio-btn) {
        position: relative;
        display: block;
        margin-bottom: 0;
        text-align: center;
        background: #fff;
        cursor: pointer;
        .fake-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 37px;
          padding: .25rem .5rem;
          color: color("primary-color", "base-2");
          font-size: .9375rem;
          font-weight: 700;
          line-height: 1.3;
          background: transparent;
          border: 2px solid #fff;
          border-radius: 2px;
          transition: border-color .3s ease-in-out 0s,color .3s ease-in-out 0s;
        }
        &:hover {
          .fake-btn {
            color: color("primary-color", "base");
            border-color: color("primary-color", "base");
          }
        }
      }
    }
  }
}
</style>
